<template>
  <div class="slices-panel">
    <div class="no-data-disclaimer" v-if="!data">
      <div class="label">
        <div class="title">Nothing to show</div>
        <div class="subtitle">
          Select at least 1 subject to visualize the Slices
        </div>
      </div>
    </div>
    <template v-else-if="planeOptions">
      <div class="top-panel">
        
        <multi-select-component
          label="slices"
          mode="multiple"
          v-model="currentSlices"
          :options="planeOptions"
        ></multi-select-component>
        <div class="time-slider">
          <div class="label">Time: {{currentTime}}s</div>
          <vue-slider
            type="range"
            :min="0"
            :max="totalDuration"
            :duration="0"
            :interval="0.01"
            :tooltip="'none'"
            :tooltip-formatter="'{value}s'"
            v-model="currentTime"
          />
        </div>
        <div class="play-toggle" :class="{playing: playing, paused:!playing}" @click="togglePlay"></div>
        <!-- <div class="brush-toggle" :class="{active: brushMode==='y'}"  @click="brushMode!=='y'?brushMode='y':brushMode=null">BRUSH Y</div> -->
      </div>
      <div class="slices-container" v-if="activePatientGroups">
        <!-- <img ref="image" rel:auto_play="0"/> -->
        <template v-if="currentSlices.length > 0">
          <div class="patient-slices"  v-for="patient in activePatientGroups" :key="patient.id">
            <!-- {{patient}} -->
            <div class="slices-title">Subject {{patient.subject.templateId}} - {{patient.trialMeta.name}}</div>
            <div class="slices-row" v-if="patient && patient.vids">
              <div class="slice-item" v-for="(vid) in patient.vids" :key="vid.fileName">
                <slices-panel-case 
                  :currentTime="currentTime"
                  :fileName="vid.fileName"
                  :vidSize="vidSize"
                  @loaded="(d)=>totalDuration = d"
                  ref="videoComponents"
                />
                <div class="slice-label">{{vid.label}}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="no-slices-disclaimer">
            <div class="label">
              <div class="title">Nothing to show</div>
              <div class="subtitle">
                Select at least 1 plane to visualize the Slices
              </div>
            </div>
          </div>
        </template>
        
        <!-- <div class="patient" v-for="patient in data" :key="patient.id">
          <img src="dfas"/>
        </div> -->
      </div>
    </template>
  </div>
</template>

<script>

import MultiSelectComponent from '@/components/MultiSelectComponent'
import widgetContent from '@/mixins/widgetContent'
import SlicesPanelCase from './SlicesPanelCaseMp4'
import VueSlider from 'vue-slider-component'
import Api from '@/api'
export default {
  name: 'SlicesPanel',
  components: {MultiSelectComponent, SlicesPanelCase, VueSlider},
  props: ['data'],
  mixins: [widgetContent],
  data () {
    // let combinedOptions = ['LAX1','LAX2','LAX3','LAX4','LAX5','SAX1','SAX2','SAX3','SAX4','SAX5','SAX6']
    return {
      currentSlices: [], //[combinedOptions[0]],
      currentTime: 0,
      // combinedOptions: [], //combinedOptions,
      brushMode: null,
      vidSize: 0,
      playing: false,
      totalDuration: 0
    }
  },
  computed: {
    planeOptions(){
      return (this.data && this.patientGroups && this.patientGroups[0] && this.patientGroups[0].vids.map((v)=>v.label)) || []
    },
    activePatientGroups(){
      return this.data && this.patientGroups && this.patientGroups.map((p)=>{
        return {
          ...p,
          vids: p.vids.filter((v)=>this.currentSlices.indexOf(v.label)>=0)
        }
      })
    }
  },
  asyncComputed:{
    patientGroups(){
      let reqs = (this.data || []).map(async (patient)=>{
        return Api.getPlanesByIds(this.$route.params.project,patient.trialId,patient.subject.templateId).then(response=>{
          // let view = 'lax' //this.config.direction==='short'?'sax':'lax'
          let planeDefs = response//.filter((p)=>p.Type==='PLANE' && this.currentSlices.indexOf(p.Name)>=0)
          // console.log("planeDefs",planeDefs)
          return {
            ...patient,
            vids: planeDefs.map((p)=>{
              return {
                fileName: p.mp4,
                label: p.Name
              }
            })
          }
        })
      })
      return reqs.length>0?Promise.all(reqs):[]
    },
    
    // vidGroups(){
    //   console.log("this.currentSlices",this.currentSlices)
    //   console.log("this.data",this.data)
    //   let reqs = (this.data || []).map(async (patient)=>{
    //     return Api.getPlanesByIds(this.$route.params.project,patient.trialId,patient.subject.templateId).then(response=>{
    //       // let view = 'lax' //this.config.direction==='short'?'sax':'lax'
    //       let planeDefs = response.filter((p)=>p.Type==='PLANE' && this.currentSlices.indexOf(p.Name)>=0)
    //       console.log("planeDefs",planeDefs)
    //       return {
    //         ...patient,
    //         vids: planeDefs.map((p)=>{
    //           return {
    //             fileName: p.mp4,
    //             label: p.Name
    //           }
    //         })
    //       }
    //     })
    //   })
    //   return Promise.all(reqs)
    // },
    // planes(){
    //   // return Api.getTrial({project: this.$route.params.project,trial: this.data.trialId})
    //   // {projectId: params.project.id, trialId: params.trial.id, templateId:params.subject.subject.templateId}
      
    //   Api.getPlanesByIds(this.$route.params.project,21,23).then(response=>{
    //     let view = this.config.direction==='short'?'sax':'lax'
    //     let planeDefs = response.filter((p)=>p.Type==='PLANE' && p.View===view)
    //     return Promise.all(planeDefs.map((p)=>{
    //       return p.mp4
    //     }))
    //   })
    // }
  },
  methods: {
    setVidSize(){
      let maxCells = Math.max((this.patientGroups || []).length,this.currentSlices.length)
      this.vidSize = Math.max(140,Math.min(Math.min(this.size.height-200,480),this.size.width/(maxCells+1)))
    },
    sync(){
      this.$refs.videoComponents.forEach((vc)=>vc.sync(this.currentTime))
    },
    togglePlay(){
      this.playing = !this.playing
      if(this.playing) {
        this.$refs.videoComponents.forEach((vc)=>vc.playVid())
        this.updateTime()
      } else {
        this.$refs.videoComponents.forEach((vc)=>vc.pauseVid())
        this.sync()
      }
    },
    stop() {
      this.playing = false
      this.$refs.videoComponents.forEach((vc)=>vc.pauseVid())
      this.sync()
    },
    updateTime(){
      let now = Math.round(performance.now())
      if(!this.lastRender) this.lastRender=now
      this.currentTime += (now - this.lastRender)/1000
      if(this.currentTime>=this.totalDuration) this.currentTime = 0
      this.currentTime = Math.round(this.currentTime*100)/100
      this.lastRender = now
      if(this.playing) requestAnimationFrame(this.updateTime)
      else this.lastRender=null
    }
  },
  watch: {
    size(){
      this.setVidSize()
    },
    patientGroups(){
      this.stop()
      this.setVidSize()
    },
    currentSlices(){
      this.stop()
      this.setVidSize()
    },
    planeOptions(){
      if(this.currentSlices.length===0 && this.planeOptions[0]) this.currentSlices = [this.planeOptions[0]]
    },
    currentTime(){
      if(!this.playing) this.sync()
    }
  }
}
</script>

<style lang="stylus" scoped>
.slices-panel
  display: flex
  flex-direction: column
  position: relative
  height 100%
  .slices-container
    flex: 1 1 auto
    overflow: auto
    display flex
    flex-wrap wrap
    align-items: flex-start;
    //chapuzilla resizer...
    margin-bottom 40px
    .patient-slices
      background rgba(255,255,255,0.1)
      margin 10px
      padding 5px
      overflow auto
      .slices-title
        m-font-size(14,12)
        font-weight 400
        overflow hidden
        text-overflow ellipsis
        max-width: 140px; //BAsura, pero no encuentro la manera de "calcular" esto en funcion de la seleccion...
      .slices-row
        display flex
        flex-wrap wrap
        .slice-item
          display flex
          flex-direction column
          margin 4px
          flex: 0 0 auto
          align-items: center;
          .slice-label
            m-font-size(10)    

  .top-panel
    display: flex
    
    .multi-select-component
      flex: 1 1 30%
      margin: 15px 30px
    .time-slider
      flex: 1 1 70%
      margin: 15px 30px
      display flex
      flex-direction column
      align-items flex-start
      .label
        color: #fff !important
        m-font-size(12, 14)
        text-transform: capitalize
        margin-bottom: 5px
      
      >>> .vue-slider
        // flex 1 1 auto
        width: 100% !important;
        cursor pointer
        padding: 12px 0px 7px 0px !important
        &:hover
          .vue-slider-dot-handle-focus
            border-color: $radical-red

        .vue-slider-rail
          background-color: $heather
          height: 2px

        .vue-slider-process
          background-color: $radical-red

        .vue-slider-dot-handle
          border-color: rgba($radical-red, 0.75)

          &:hover
            border-color: $radical-red

        .vue-slider-dot-handle-focus
          box-shadow: 0 0 0 5px rgba($radical-red, 0.2)
          
    .play-toggle
      flex 0 0 40px
      margin-right 10px
      margin-left: 20px;
      align-self: center;
      &.paused
        m-icon("action-play", 40, "px")
        width auto

      &.playing
        m-icon("action-pause", 40, "px")
        width auto
  .no-data-disclaimer,.no-slices-disclaimer
    .label
      color: #fff
      left: 50%
      position: absolute
      text-align: center
      top: 50%
      transform: translate(-50%, -50%)

      .title
        m-font-size(18)
        font-weight $fw-bold
        margin-bottom 20px

      .subtitle
        m-font-size(14)
</style>